import { useQuery } from '@tanstack/react-query'
import { useApiFetch } from '../../shared/api'

interface ChronicleTeamDto {
  id: string
  name: string
  hectares: number
  groundCount: number
}

interface ChronicleTeamsResponse {
  teams: ChronicleTeamDto[]
}

export interface ChronicleTeamSummary {
  id: string
  name: string
  hectares: number
  groundCount: number
}

export interface ChronicleTeamsResult {
  teams: ChronicleTeamSummary[]
  isLoading: boolean
}

export function useChronicleTeams(): ChronicleTeamsResult {
  const call = useApiFetch()
  const { data, isPending } = useQuery({
    queryKey: ['chronicle', 'teams'],
    queryFn: async (): Promise<ChronicleTeamSummary[]> => {
      const response = await call<ChronicleTeamsResponse>('/chronicle/me/teams')
      return response.teams
    },
    staleTime: 5 * 60 * 1000,
  })

  return { teams: data ?? [], isLoading: isPending }
}
